import { borderRadius, semanticColors } from '@moderneinc/design-system-tokens';

// Shared error-card chrome: the run-level error banner
// (pages/results/[organization]/[recipeRunId].tsx) and Error500's expandable
// error details use this so error surfaces stay visually consistent.
// RepositoryErrorAlert deliberately opts out — see SURFACE_SX there.
export const ERROR_SURFACE_SX = {
  borderRadius: `${borderRadius.m}px`,
  border: `1px solid ${semanticColors.color.status.error.solid}`,
  backgroundColor: semanticColors.color.status.error.bg
} as const;
